/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_AmountInputs */



/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Invoice_AmountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const invoice_amount = /** @type {((inputs?: Invoice_AmountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_AmountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Montant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Menge")
	if (locale === "it") return /** @type {LocalizedString} */ ("Quantità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cantidad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("数量")
	if (locale === "ja") return /** @type {LocalizedString} */ ("額")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मात्रा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quantia")
	return /** @type {LocalizedString} */ ("Amount")
});